module.exports = __webpack_public_path__ + "img/CryptoTaxSpace_Logo_Black.91ebaabe.png";